import gql from 'graphql-tag'

export const FullVehicleFragment = gql`
  fragment FullVehicle on Vehicle {
    id
    slug
    stage

    title
    teaser
    ctaLabel
  }
`

export default gql`
  query Vehicle($vehicleSlug: String!, $lang: [Locale!]!, $stage: Stage!) {
    vehicle(where: { slug: $vehicleSlug } locales: $lang stage: $stage) {
      ...FullVehicle
    }
  }
  ${FullVehicleFragment}
`



// WEBPACK FOOTER //
// ./src/queries/vehicle.js